'use strict'
import { renderWaves } from "../wavesAnimation.js";
const countSlides = $('#header-gallery .images-holder').find('.image').length;
const sliderImages = $('#header-gallery .images-holder').find('.image');

import ZingTouch from 'zingtouch';

let defSlider = $.Deferred();
let timer;
$.when(defSlider).done(function () {
    
});

let getNextSlide = () => {
    const current = sliderImages.closest('.images-holder').find('.active').index();
    let nextSlide = 0;
    if(current + 1 < countSlides){
        nextSlide = current + 1;
    }
    getSlide(nextSlide);
}

let getPrevSlide = () => {
    const current = sliderImages.closest('.images-holder').find('.active').index();
    let nextSlide = current - 1;
    
    if(nextSlide < 0){
        nextSlide = countSlides - 1;
    }
    getSlide(nextSlide);
}


let initSliderNav = () => {

    var zt = new ZingTouch.Region(document.body);
    var myElement = document.getElementById('header-gallery');

    zt.bind(myElement, 'swipe', function(e){
        const dir = e.detail.data[0].currentDirection;
        if(dir >= 90 && dir < 270){
            getNextSlide();
        }
        else{
            getPrevSlide();
        }
    }, false);



    
    $('.dots-nav').removeClass('hidden');
    $('.dots-nav').find('a').on('click', function(e){
        e.preventDefault()
        getSlide($(this).closest('li').index());
    })
}


let getSlide = (slideId) => {
    clearTimeout(timer);
    sliderImages.removeClass('active');
    sliderImages.eq(slideId).addClass('active');
    $('.dots-nav').find('li').removeClass('active');
    $('.dots-nav').find('li').eq(slideId).addClass('active');
    timer = setTimeout(getNextSlide, 5000);
}

let preloadSlider = () => {
    
    renderWaves($('#slider-preloader')[0]);
    const slide = sliderImages.eq(0);
    const slideUrl = slide.find('img').attr("src").replace('url(','').replace(')','').replace(/\"/gi, "");
    let firstImage = new Image();
    firstImage.src = slideUrl;

    firstImage.onload = () => {
        $('.dots-nav').append('<li><a href="#"></a></li>');
        defSlider.resolve();
        $('#slider-preloader').addClass('hidden');
        getSlide(0);
        if(countSlides > 1){
            sliderImages.each(function(){
                const slide = $(this);
                const slideId = slide.index();
                if(slideId > 0){
                    const slideUrl = slide.find('img').attr("src").replace('url(','').replace(')','').replace(/\"/gi, "");
                    let image = new Image();
                    image.src = slideUrl;
                    image.onload = () => {
                        $('.dots-nav').append('<li><a href="#"></a></li>');
                        if(slideId + 1 == countSlides){
                             initSliderNav();
                        }
                    }
                }
            })
        }
        else{
            return;
        }
    }
}

jQuery(function () {
    preloadSlider()
})